import { createSlice } from "@reduxjs/toolkit";

export const contactSlice = createSlice({
  name: "contact",
  initialState: {
    formData: { name: "", email: "", phone: "", message: "" },
    isSubmitting: false,
    submitSuccess: false,
  },
  reducers: {
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setSubmitSuccess: (state, action) => {
      state.submitSuccess = action.payload;
    },
    resetForm: (state) => {
      state.formData = { name: "", email: "", phone: "", message: "" };
      state.submitSuccess = false;
    },
  },
});
